import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Fieldset, Legend, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Input,
    Collapse
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect, withRouter } from "react-router-dom"
import apiResponse from '../../../../../services/apiResponse'

import { cancelToken } from '../../../../../services/adapters/kepegawaian/kenaikanpangkatService'
import ReportBloc from '../Blocs/ReportBloc'
import MinioClient from '../../../../../services/minioClient'

class ReportDetailModal extends Component {

    reportBloc = new ReportBloc()
    minioClient = new MinioClient()
    timer
    source
    defaultSize = 10

    constructor(props) {
        super(props)
        this.state = {
            dataForm: null,
            documentUrl: null,
            optionSignatureOfficer: [
                { label: "Kepala Biro Umum", value: "Kepala Biro Umum" },
                { label: "Sekretariat Utama", value: "Sekretariat Utama" },
                { label: "Atas Nama", value: "Atas Nama" }
            ],
        }
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function (data) {
            var newObj = {};
            newObj["label"] = data[label];
            newObj["value"] = data[value];

            return newObj;
        });
    };

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.props.reportDetail?.employee_wfh_detail_uuid,
                nip: this.props.nip,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        // await this.reportBloc.fetchReport(this.state.dataForm)
        const dataForm = generateFormData(this.state.dataForm, 'file')
        await this.reportBloc.fetchReport(dataForm)
        // if (this.props.uuid === '') {
        //     await this.createBloc.fetchCreate(this.state.dataForm)
        // } else {
        //     await this.createBloc.fetchCreateDetail(this.state.dataForm)
        // }
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }


    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
    }

    componentDidMount() {
        this.setTokenAPI()
        this.getMinioUrl()

        this.reportBloc.reportChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    //this.props.setUuid(result.data.response.employee_transfer_uuid)
                    //this.createBloc.fetchCreateDetail({ ...this.state.dataForm, uuid: result.data.response.employee_transfer_uuid })
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    this.props.toggle()
                    this.props.handleReload()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    this.props.toggle()
                    break
                default:
                    break;
            }
        })
    }

    getMinioUrl = () => {
        if (this.props.reportDetail?.documents_path) {
            this.minioClient.get(this.props.reportDetail.documents_path).then((url) => {
                this.setState({
                    documentUrl: url
                })
            })
        } else {
            this.setState({
                documentUrl: null
            })
        }
    }

    componentWillUnmount() {

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.reportDetail !== this.props.reportDetail) {
            this.getMinioUrl()
        }
    }

    render() {
        return (
            <Fragment>
                <Modal isOpen={this.props.modal} size='lg' toggle={this.props.toggle}>
                    <ModalHeader toggle={this.props.toggle}>Input Laporan WFH</ModalHeader>
                    <ModalBody>
                        <AvForm
                            className="needs-validation"
                            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                        >
                            {/* <Row className="mb-10">
                                <label
                                    htmlFor="no_sk"
                                    className="col-md-4 col-form-label"
                                >
                                Deskripsi Pekerjaan Saat WFH
                                </label>
                                <Col md="8">
                                    <AvField
                                        name="employee_wfh_detail_report"
                                        id="employee_wfh_detail_report"
                                        placeholder="Deskripsi Pekerjaan Saat WFH"
                                        type="textarea"
                                        errorMessage="Masukan Deskripsi Pekerjaan Saat WFH"
                                        className="form-control"
                                        readOnly
                                        // validate={{ required: { value: true } }}
                                        value={this.props.reportDetail?.employee_wfh_report_description}
                                    />
                                </Col>
                            </Row>   */}

                            <Row className="mb-3">
                                <label
                                    className="col-md-4 col-form-label"
                                >
                                    File Pendukung
                                </label>
                                <Col md="6">
                                    <div className="mt-2">
                                        {
                                            this.state.documentUrl != null ?
                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.documentUrl}>
                                                    Download File <i className="fa fa-download ms-1"></i>
                                                </a>
                                                : 'Tidak Ada File'
                                        }
                                    </div>
                                </Col>
                            </Row>


                            <ModalFooter>
                                <Button color="secondary" onClick={this.props.toggle}>Close</Button>{' '}
                                {/* <Button color="primary" type="submit">Submit dan Ajukan</Button> */}
                            </ModalFooter>
                        </AvForm>
                    </ModalBody>
                </Modal>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"
                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"
                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"
                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"
                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}
                    response={this.confirmResponse}
                />

            </Fragment>
        )
    }
}

export default withRouter(ReportDetailModal)